import React from 'react';
import BottomNavigation from '../components/BottomNavigation';
import './Calendar.css';

const Calendar: React.FC = () => {
  const events = [
    { id: 1, title: 'Math Class', time: '9:00 AM', date: '2024-01-15', type: 'class' },
    { id: 2, title: 'English Exam', time: '2:00 PM', date: '2024-01-15', type: 'exam' },
    { id: 3, title: 'Science Lab', time: '10:00 AM', date: '2024-01-16', type: 'lab' },
    { id: 4, title: 'History Lecture', time: '11:00 AM', date: '2024-01-17', type: 'lecture' }
  ];

  return (
    <div className="calendar-page">
      <header className="calendar-header">
        <h1>Calendar</h1>
        <p className="calendar-subtitle">Your schedule and events</p>
      </header>

      <div className="calendar-content">
        <div className="calendar-events">
          {events.map((event) => (
            <div key={event.id} className="calendar-event-card">
              <div className="event-date">
                <div className="event-day">15</div>
                <div className="event-month">Jan</div>
              </div>
              <div className="event-info">
                <h3 className="event-title">{event.title}</h3>
                <div className="event-time">🕐 {event.time}</div>
                <span className={`event-type ${event.type}`}>{event.type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Calendar;

